export const Perfil = {
  "Meu Perfil": "O Meu Perfil",
  "Código": "Código",
  "Alterar senha": "Alterar Palavra-passe",
  "Sair": "Sair",
  "Dados Pessoais": "Dados Pessoais",
  "Email:": "Email:",
  "Função:": "Função:",
  "Turno:": "Turno:",
  "Contato": "Contacto",
  "Adicionar Whatsapp": "Adicionar Whatsapp",
  "Dados da Empresa": "Dados da Empresa",
  "Nome:": "Nome:",
  "Data de admissão:": "Data de admissão:",
  "Telefone:": "Telefone:",
  "Visualizar LinkedIn": "Visualizar LinkedIn",
  "Adicionar LinkedIn": "Adicionar LinkedIn",
  "Tivemos um problema com a conexão. Tente novamente atualizando a página.": "Tivemos um problema com a ligação. Tente novamente atualizando a página.",
  "Aviso": "Aviso",
  "Não foi possivel realizar o envio da imagem. Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.": "Não foi possivel realizar o envio da imagem. Motivo: ficheiro muito grande, por favor envie um ficheiro com menos de 2MB."
};


// WEBPACK FOOTER //
// ./src/resources/ptPT/Perfil.js